import { HttpTypes } from '@/types';
import {
  AdminMenuListResponse,
  AdminNavigationCreateResponse,
  AdminNavigationDeleteResponse,
} from '@/types/http';
import { INavigation } from '@/types/navigation';
import { AxiosInstance } from 'axios';

class Navigation {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<AdminMenuListResponse> {
    const result = await this.client.get('/sites/menu/list', {
      params: queryParams,
    });
    return result.data;
  }

  async retrieve(id: string): Promise<HttpTypes.IResponse<INavigation>> {
    const result = await this.client.get(`/sites/menu/detail/${id}`);
    return result.data;
  }

  async create(
    data: HttpTypes.AdminNavigationCreatePayload
  ): Promise<HttpTypes.IResponse<AdminNavigationCreateResponse>> {
    const result = await this.client.post('/sites/menu/save', data);
    return result.data;
  }

  async delete(id: string): Promise<HttpTypes.IResponse<AdminNavigationDeleteResponse>> {
    const result = await this.client.delete(`/sites/menu/${id}`);
    return result.data;
  }
}

export default Navigation;
